export default __webpack_public_path__ + "static/media/knightswap_finance.7c9365bf.jpeg";